import React from 'react';
import InfoTooltip from '../../info-tooltip/info-tooltip';
import { MeetingTimeZoneHelper } from '../../../utils/meetingTimeZoneHelper';

interface ScheduledTimeInfoProps {
    dateStart: Date | string;
    dateEnd: Date | string;
    /** The zone the meeting was scheduled in, e.g. 'CDT'. */
    timeZone?: string | null;
    /** Unique per meeting, e.g. `${meeting.id}-start`. */
    tooltipKey: string;
}

/**
 * An info icon whose tooltip gives the time a meeting was scheduled for in the zone it was scheduled
 * in, e.g. 'Scheduled for / 10/06/2026 10:00 AM – 11:00 AM CDT'. Nothing when that zone is unknown.
 * The tooltip opens above the icon and extends to its left, so it stays inside a meeting tile whose
 * start time sits at the tile's right edge.
 */
export const ScheduledTimeInfo = (props: ScheduledTimeInfoProps) => {
    const note = MeetingTimeZoneHelper.getScheduledTimeNote(
        props.dateStart,
        props.dateEnd,
        props.timeZone
    );
    if (!note) {
        return null;
    }

    return (
        <InfoTooltip
            text={note.replace('Scheduled for ', 'Scheduled for<br/>')}
            idText={`meeting-start-${props.tooltipKey}`}
            place="top-end"
        />
    );
};

/** A meeting's start time in the viewer's zone with that zone named, e.g. '10:00 AM EDT', and its scheduled-time icon. */
export const MeetingStartTime = (props: ScheduledTimeInfoProps) => (
    <>
        {MeetingTimeZoneHelper.formatTime(props.dateStart)}
        <ScheduledTimeInfo {...props} />
    </>
);
